/**
 * BPP Backend API (Version: 1.0.0.0)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export enum GoUserUnternehmensFunktion {
    Geschaeftsfuehrer = 'Geschaeftsfuehrer',
    Makler = 'Makler',
    BackofficeMitarbeiter = 'BackofficeMitarbeiter'
  }

    export const GoUserUnternehmensFunktionTranslocoMap: Record<GoUserUnternehmensFunktion, string> = {
    [GoUserUnternehmensFunktion.Geschaeftsfuehrer]: 'goUserUnternehmensFunktion.geschaeftsfuehrer',
    [GoUserUnternehmensFunktion.Makler]: 'goUserUnternehmensFunktion.makler',
    [GoUserUnternehmensFunktion.BackofficeMitarbeiter]: 'goUserUnternehmensFunktion.backofficeMitarbeiter',
    };

    export const GoUserUnternehmensFunktionOptions = [
  { value: GoUserUnternehmensFunktion.Geschaeftsfuehrer, labelKey: 'goUserUnternehmensFunktion.geschaeftsfuehrer' },
  { value: GoUserUnternehmensFunktion.Makler, labelKey: 'goUserUnternehmensFunktion.makler' },
  { value: GoUserUnternehmensFunktion.BackofficeMitarbeiter, labelKey: 'goUserUnternehmensFunktion.backofficeMitarbeiter' },
    ];

